import axios from "axios";
import {FORBIDDEN_URL, LOGIN_URL} from "./common";


export const brokerListUpdateRequests = async ({status, page, per_page}) => {
    try {
        const response = await axios.get(`/broker/update-request/index?status=${status}&page=${page}&per_page=${per_page}`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const getUpdateRequestsFilterCount = async () => {
    try {
        const response = await axios.get(`/broker/update-request/filters`);
        if (response.status === 401) {
            // window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error get update requests filters count :', error);
        return null;
    }
};

export const deleteUpdateRequests = async (updateRequestId) => {
    try {
        const response = await axios.delete(`/broker/update-request/${updateRequestId}/delete`);
        if (response.status === 401) {
            // window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error delete update requests :', error);
        return null;
    }
};

export const resendUpdateRequests = async (updateRequestId, message) => {
    try {
        const response = await axios.post(`/broker/update-request/${updateRequestId}/resend`, {
            message: message
        });
        if (response.status === 401) {
            // window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error resend update requests :', error);
        return null;
    }
};


export const getBrokerReminders = async () => {
    try {
        const response = await axios.get(`/broker/account/reminders`);
        if (response.status === 401) {
            // window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error get update requests filters count :', error);
        return null;
    }
};

export const getWebinars = async ({page, per_page, status, product}) => {
    try {
        const response = await axios.get(`/broker/mav?&status=${status}` + (product ? `&products=${product}` : ``) + `&page=${page}&per_page=${per_page}`);
        if (response.status === 401) {
            // window.location.href = LOGIN_URL;
            return null;
        }
        return response.data;
    } catch (error) {
        console.error('Error get webinars :', error);
        return null;
    }
};

export const registerForWebinar = async (webinarId) => {
    try {
        const response = await axios.post(`/broker/mav/${webinarId}/register`, {
        });
        if (response.status === 401) {
            // window.location.href = LOGIN_URL;
            return null;
        }

        return response.data;
    } catch (error) {
        console.error('Error registering for webinar :', error);
        return null;
    }
};

export const getMavProducts = async () => {
    try {
        const response = await axios.get(`/broker/mav/products`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};

export const getIsBrokerSso = async () => {
    try {
        const response = await axios.get(`/broker/account/sso`);
        if (response.status === 401) {
            window.location.href = LOGIN_URL;
            return null;
        } else {
            return response.data;
        }
    } catch (error) {
        if (error.response.status === 403) {
            window.location.href = FORBIDDEN_URL;
        }
        return null;
    }
};
